import React from 'react';
import { useParams } from 'react-router-dom';

interface TermsContentProps {
  serviceKey?: string; // Make serviceKey optional as it might be passed directly
}

const TermsPageContent: React.FC<TermsContentProps> = ({ serviceKey: propServiceKey }) => {
  const params = useParams<{ serviceKey: string }>();
  const serviceKey = propServiceKey || params.serviceKey;

  return (
    <div className="text-foreground">
      <h2 className="text-2xl font-semibold mb-4">Terms of Service</h2>
      <p className="mb-4 text-sm text-foreground-muted">
        Welcome to {serviceKey || 'our service'}! Please read these Terms of Service ('Terms') carefully before using our platform.
      </p>
      <div className="space-y-3 text-sm">
        <section>
          <h3 className="font-medium mb-1">1. Acceptance of Terms</h3>
          <p className="text-foreground-muted">
            By accessing or using our service, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, do not use the service.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">2. Service Description</h3>
          <p className="text-foreground-muted">
            Our platform provides transportation booking services. We reserve the right to modify or discontinue the service at any time without notice.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">3. User Responsibilities</h3>
          <p className="text-foreground-muted">
            You agree to provide accurate information when creating an account and using our services. You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">4. Prohibited Conduct</h3>
          <p className="text-foreground-muted">
            You agree not to misuse the service, including but not limited to: engaging in illegal activities, attempting to disrupt the service, or violating the rights of others.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">5. Intellectual Property</h3>
          <p className="text-foreground-muted">
            All content and materials available on our service, including but not limited to text, graphics, website name, code, images, and logos are the intellectual property of {serviceKey || 'our company'} and are protected by applicable copyright and trademark law.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">6. Limitation of Liability</h3>
          <p className="text-foreground-muted">
            Our service is provided 'as is'. We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the service.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">7. Governing Law</h3>
          <p className="text-foreground-muted">
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which {serviceKey || 'our company'} is located, without regard to its conflict of law provisions.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">8. Changes to Terms</h3>
          <p className="text-foreground-muted">
            We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page. Your continued use of the service after any such changes constitutes your acceptance of the new Terms.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">9. Contact Information</h3>
          <p className="text-foreground-muted">
            If you have any questions about these Terms, please contact us at support@{serviceKey || 'example'}.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPageContent;
